import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container my-12 md:mt-25 md:mb-15 md:px-10',
    header: 'mb-5 flex flex-col gap-2 md:mb-8 md:flex-row md:justify-between',
    title: 'heading-2xl md:heading-3xl',
    link: 'w-fit p-0',
    linkContent: 'flex gap-1.5 lg:gap-4.5',
    list: '[--slide-size:auto] [--slide-spacing:20px] lg:[--slide-size:33%]',
    item: 'max-w-80 md:max-w-110'
  }
});
